export interface CCBPageEventDetail {
  location: string;
}
export interface CCBActivityEventDetail {
  projectId?: number | null;
  participationId?: string;
  activity?: string | null;
  activityTitle?: string | null;
  userId?: number | null;
}

type EventTypes = 'ccb:activity:visible' | 'ccb:activity:hide' | 'ccb:page';

interface EventMap {
  'ccb:page': CustomEvent<CCBPageEventDetail>;
  'ccb:activity:visible': CustomEvent<CCBActivityEventDetail>;
  'ccb:activity:hide': CustomEvent<CCBActivityEventDetail>;
}

export type CustomEventHandler<K extends EventTypes> = (
  event: EventMap[K],
) => void;

export const addTypedEventListener = <K extends EventTypes>(
  type: K,
  listener: (event: CustomEvent<EventMap[K]['detail']>) => void,
) => {
  document.addEventListener(type, listener as EventListener);
};

export const removeTypedEventListener = <K extends EventTypes>(
  type: K,
  listener: (event: CustomEvent<EventMap[K]['detail']>) => void,
): void => {
  window.removeEventListener(type, listener as EventListener);
};

const createCustomEvent = (name: string, params: object) => {
  if (typeof window.CustomEvent === 'function') {
    return new window.CustomEvent(name, params);
  }

  const appendedParams = {
    ...params,
    bubbles: false,
    cancelable: false,
    detail: undefined,
  };
  const event = document.createEvent('CustomEvent');
  event.initCustomEvent(
    name,
    appendedParams.bubbles,
    appendedParams.cancelable,
    appendedParams.detail,
  );
  return event;
};

export const dispatchCustomEvent = <K extends EventTypes>(
  type: K,
  detail: EventMap[K]['detail'],
): boolean => {
  const event = createCustomEvent(type, { detail }) as EventMap[K];
  return document.dispatchEvent(event);
};
